const SpotifyAuthService = {

  authorizeApp() {
    return new Promise((resolve, reject) => {
      axios.post('spotify/auth/app')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  authorizeUser(payload) {
    return new Promise((resolve, reject) => {
      axios.post('spotify/auth/user', payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

  refreshAccessToken(refreshToken) {
    return new Promise((resolve, reject) => {
      axios.post('spotify/auth/refresh', refreshToken)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default SpotifyAuthService;
